import Button from '@ingka/button';
import Tooltip from '@ingka/tooltip';
import { useNavigate } from 'react-router-dom';
import filters from '@ingka/ssr-icon/paths/filters';
import { useSelector } from 'react-redux';
import { masterCatalogIdSelector } from '../../../store/selectors/catalog/ids';
import {
  selectCurrentLanguageCode,
  selectCurrentRetailUnit,
} from '../../../store/slices/intl';
import SSRIcon from '@ingka/ssr-icon';
import informationCircle from '@ingka/ssr-icon/paths/information-circle';
import { useGetFilterNotifications } from '../../IndexableFilters/queries/useGetFilterNotifications';
import styles from './FilterLink.module.scss';
import { IS_DEV } from '../../../utils/env';
import cx from 'classnames';
import { FILTER_EDITOR_ROLE } from '../../IndexableFilters/util';
import { selectRoles } from '../../../store/slices/roles';

export const FilterLink = () => {
  const languageCode = useSelector(selectCurrentLanguageCode);
  const isFilterEditor = useSelector(selectRoles).includes(FILTER_EDITOR_ROLE);

  const { data } = useGetFilterNotifications(isFilterEditor);
  const retailUnit = useSelector(selectCurrentRetailUnit);
  const catalogId = useSelector(masterCatalogIdSelector);
  const navigate = useNavigate();
  return (
    <Tooltip
      describedById="indexable-filters-tooltip"
      interactiveCustomTrigger
      position="bottom"
      tooltipText="Indexable filters"
    >
      <Button
        id="indexable-filters-button"
        aria-label="Go to indexable filters"
        size="small"
        name="Go to indexable filters"
        type="tertiary"
        iconOnly
        role="button"
        ssrIcon={filters}
        onClick={() => {
          const to = `${retailUnit}/${languageCode}/filters/${catalogId}?t=categories`;
          navigate(to);
        }}
      >
        {data && data?.length > 0 ? (
          <SSRIcon
            className={cx(styles.icon, { [styles.devIcon]: IS_DEV })}
            paths={informationCircle}
          />
        ) : null}
      </Button>
    </Tooltip>
  );
};
